<template>
  <div
    class="conteudo box-shadow-primary p-4 bg-white rounded-lg font-light text-left"
  >
    <h1 class="text-xl font-medium leading-tight mb-3">{{ title }}</h1>
    <div v-html="text"></div>
  </div>
</template>

<script>
export default {
  name: "LessonText",
  props: ["text", "title"],
  data() {
    return {};
  }
};
</script>

<style>
.conteudo h1 {
  margin-top: 0;
}

.conteudo h2 {
  color: #9684b5;
  font-size: 20px;
  text-transform: uppercase;
  line-height: 1.2;
  margin-bottom: 5px;
  margin-top: 20px;
}
.conteudo h3 {
  text-transform: uppercase;
  margin-top: 15px;
  margin-bottom: 5px;
  font-weight: normal;
  color: #999;
  padding-top: 8px;
}

.conteudo ul {
  list-style: none;
  /* list-style-type: initial;
  list-style-position: outside; */
  margin-left: 30px;
  margin-top: 8px;
  margin-bottom: 10px;
  line-height: 1.3;
  font-size: 0.95rem;
}
.conteudo ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #9684b5; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  font-size: 20px;
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}

.conteudo ol {
  list-style: decimal;
  margin-left: 30px;
  margin-top: 8px;
  margin-bottom: 10px;
  line-height: 1.3;
  font-size: 0.95rem;
}

.conteudo p {
  margin-bottom: 10px;
  font-weight: lighter;
}

.conteudo blockquote {
  background-color: rgba(153, 128, 250, 0.1);
  color: #8b8ba7;
  padding: 10px 15px;
  padding-left: 25px;
  border-left: 3px solid #8b8ba7;
  font-size: 0.9rem;
  margin-bottom: 15px;
  margin-top: 15px;
}

.conteudo blockquote:before {
  content: url("../assets/img/icons/book.svg");
  position: absolute;
  width: 10px;
  margin-left: -40px;
  transform: rotate(-10deg);
}

.conteudo blockquote > p {
  color: #8b8ba7;
}
.conteudo blockquote > p:last-child {
  margin-bottom: 0;
}
.conteudo li {
  /* //   list-style-type: circle; */
}
</style>
